import { AnyAction } from 'redux';
import { FETCH_DATA_SOURCES, UPDATE_ID_TOKEN, SAVE_DATA_SELECTED_ASSET } from './actionTypes';

export const updateIdToken = (): AnyAction => ({
  type: UPDATE_ID_TOKEN,
});

export const fetchDataSources = (): AnyAction => ({
  type: FETCH_DATA_SOURCES,
});

export const saveDataSelectedAsset = (dataSourceName: string, externalUrl: string, assetId: string): AnyAction => ({
  type: SAVE_DATA_SELECTED_ASSET,
  dataSourceName,
  externalUrl,
  assetId,
});
